angular.module('bmsApp.settings')
	.factory('EmailAccountsDataSvc', function ($http, $log, $window, $q, CRUDSvc) {

		return {
			index: function (params) {
				return CRUDSvc.get('api/settings/email-accounts/index', params);
			},
			read: function (params) {
				return CRUDSvc.get('api/settings/email-accounts/read', params);
			},
			delete: function (params) {
				return CRUDSvc.post('api/settings/email-accounts/delete', params);
			},
			save: function (params) {
				return CRUDSvc.post('api/settings/email-accounts/save', params);
			},
			licencesOptions: function (params) {
				return CRUDSvc.get('api/settings/email-accounts/licences-options', params);
			},
			outgoingOptions: function (params) {
				return CRUDSvc.get('api/settings/email-accounts/outgoing-email-accounts-options', params);
			},
		}

	});



